var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.initialData && _vm.initialData.length > 0
    ? _c("div", { class: _vm.direction === "across" ? "dt-bodan-box" : "" }, [
        _c("section", { staticClass: "dt-playlist dt-bodan-box-wrap" }, [
          _c("h3", { staticClass: "dt-bodan-tit" }, [
            _vm._v(
              "\n      相关播单(共" +
                _vm._s(_vm.initialData.length) +
                "个)\n    "
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "search-bodan-list",
              class: _vm.direction !== "across" ? "vertical-bodan-list" : "",
            },
            _vm._l(_vm.initialData, function (value) {
              return _c(
                "div",
                {
                  key: value.url,
                  staticClass: "search-dt-playlist-wrap",
                  class:
                    _vm.direction === "across" && _vm.initialData.length > 1
                      ? "dt-playlist-wrap-across"
                      : "",
                  attrs: { uigs: value.url },
                  on: {
                    click: function ($event) {
                      return _vm.clickout(value.url)
                    },
                  },
                },
                [
                  value.picurls
                    ? _c("div", { staticClass: "dt-playlist-img" }, [
                        value.picurls[0]
                          ? _c("div", { staticClass: "img-one" }, [
                              _c("img", {
                                directives: [
                                  {
                                    name: "lazy",
                                    rawName: "v-lazy",
                                    value: value.picurls[0],
                                    expression: "value.picurls[0]",
                                  },
                                ],
                                attrs: { alt: "" },
                              }),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        value.picurls[1]
                          ? _c("div", { staticClass: "img-two" }, [
                              _c("img", {
                                directives: [
                                  {
                                    name: "lazy",
                                    rawName: "v-lazy",
                                    value: value.picurls[1],
                                    expression: "value.picurls[1]",
                                  },
                                ],
                                attrs: { alt: "" },
                              }),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        value.picurls[2]
                          ? _c("div", { staticClass: "img-three" }, [
                              _c("img", {
                                directives: [
                                  {
                                    name: "lazy",
                                    rawName: "v-lazy",
                                    value: value.picurls[2],
                                    expression: "value.picurls[2]",
                                  },
                                ],
                                attrs: { alt: "" },
                              }),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "tag-playlist" }, [
                          _vm._v(
                            "\n            共" +
                              _vm._s(value.quantity) +
                              "部\n          "
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "dt-playlist-info" }, [
                    _c("div", { staticClass: "tit" }, [
                      _vm._v(
                        "\n            " + _vm._s(value.title) + "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "con" }, [
                      _vm._v(
                        "\n            共" +
                          _vm._s(value.quantity) +
                          "部作品\n          "
                      ),
                    ]),
                  ]),
                ]
              )
            }),
            0
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }